module.exports = __webpack_public_path__ + "3d1a48e527f61dc8aff0f9ba61869d2e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-anchor-s.png
// module id = 2244
// module chunks = 0